module.exports = __webpack_public_path__ + "img/season-highlight.b94fc6d1.svg";